//React
import React from "react";
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Material-ui
import Box from '@material-ui/core/Box';
//Part
import PartProfileTableBalloon from './PartProfileTableBalloon';
//Icon
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import ClearIcon from '@material-ui/icons/Clear';


function OkIcon() {
  return (
    <RadioButtonUncheckedIcon style={{color:'#0D58A6', fontWeight:'bold', verticalAlign:'middle'}} />
  )
}

function NgIcon() {
  return (
    <ClearIcon  style={{color:'#CB0077', fontWeight:'bold', verticalAlign:'middle'}} />
  )
}

class Comp extends React.Component {


  render() {

    let myProf = this.props.my.profile;
    let partnerProf = this.props.profile;

    return (
      <div>
        <Box
          className='round12'
          boxShadow={2}
          style={{
            background:'#FFF',
            margin:'15px'
          }}
        >
        <h2  style={{padding:'10px',textAlign:'center'}}>
          プロフィール
        </h2>
          <div align='right'>
            <PartProfileTableBalloon>
              あなたの希望条件との相性
            </PartProfileTableBalloon>
          </div>
          <table className='profileTable'>
            <tbody>
              <tr>
                <td className='title'><div className='text'>年齢</div></td>
                <td className='value'>{partnerProf.userdata_age}才</td>
                <td className='collation'>
                  {
                    ((myProf.userdata_prof_partner_age_low === '問わない') || (partnerProf.userdata_age >= myProf.userdata_prof_partner_age_low && partnerProf.userdata_age <=  myProf.userdata_prof_partner_age_high ))? (
                      <OkIcon />
                    ): (
                      <NgIcon/>
                    )
                  }
                </td>
              </tr>
              <tr>
                <td className='title'><div className='text'>地域</div></td>
                <td className='value'>{partnerProf.userdata_prof_region} {partnerProf.userdata_prof_region_detail}</td>
                <td className='collation'>
                  {
                    ((myProf.userdata_prof_partner_region === '問わない') || (myProf.userdata_prof_partner_region.split(',').includes(partnerProf.userdata_prof_region)))? (
                      <OkIcon />
                    ): (
                      <NgIcon/>
                    )
                  }
                </td>
              </tr>
              <tr>
                <td className='title'><div className='text'>出身</div></td>
                <td className='value'>{partnerProf.userdata_prof_birthplace} {partnerProf.userdata_prof_birthplace_detail}</td>
                <td className='collation'></td>
              </tr>
              <tr>
                <td className='title'><div className='text'>続柄</div></td>
                <td className='value'>{partnerProf.userdata_prof_relationship}</td>
                <td className='collation'></td>
              </tr>
              <tr>
                <td className='title'><div className='text'>仕事</div></td>
                <td className='value'>{partnerProf.userdata_prof_job}</td>
                <td className='collation'>
                  {
                    ((myProf.userdata_prof_partner_job === '問わない') || (myProf.userdata_prof_partner_job.split(',').includes(partnerProf.userdata_prof_job)))? (
                      <OkIcon />
                    ): (
                      <NgIcon/>
                    )
                  }
                </td>
              </tr>
              <tr>
                <td className='title'><div className='text'>休日</div></td>
                <td className='value'>{partnerProf.userdata_prof_holiday}</td>
                <td className='collation'></td>
              </tr>
              <tr>
                <td className='title'><div className='text'>年収</div></td>
                <td className='value'>{partnerProf.userdata_prof_income}</td>
                <td className='collation'>
                  {
                    ((myProf.userdata_prof_partner_income === '問わない') || (myProf.userdata_prof_partner_income.split(',').includes(partnerProf.userdata_prof_income)))? (
                      <OkIcon />
                    ): (
                      <NgIcon/>
                    )
                  }
                </td>
              </tr>
              <tr>
                <td className='title'><div className='text'>学歴</div></td>
                <td className='value'>{partnerProf.userdata_prof_academic}</td>
                <td className='collation'>
                  {
                    ((myProf.userdata_prof_partner_academic === '問わない') || (myProf.userdata_prof_partner_academic.split(',').includes(partnerProf.userdata_prof_academic)))? (
                      <OkIcon />
                    ): (
                      <NgIcon/>
                    )
                  }
                </td>
              </tr>
              <tr>
                <td className='title'><div className='text'>宗教</div></td>
                <td className='value'>{partnerProf.userdata_prof_religion}</td>
                <td className='collation'></td>
              </tr>
              <tr>
                <td className='title'><div className='text'>体型</div></td>
                <td className='value'>{partnerProf.userdata_prof_style}</td>
                <td className='collation'>
                  {
                    ((myProf.userdata_prof_partner_style === '問わない') || (myProf.userdata_prof_partner_style.split(',').includes(partnerProf.userdata_prof_style)))? (
                      <OkIcon />
                    ): (
                      <NgIcon/>
                    )
                  }
                </td>
              </tr>
              <tr>
                <td className='title'><div className='text'>身長</div></td>
                <td className='value'>{partnerProf.userdata_prof_height}</td>
                <td className='collation'>
                  {
                    ((myProf.userdata_prof_partner_height_low === '問わない') || (partnerProf.userdata_prof_height >= myProf.userdata_prof_partner_height_low && partnerProf.userdata_prof_height <=  myProf.userdata_prof_partner_height_high ))? (
                      <OkIcon />
                    ): (
                      <NgIcon/>
                    )
                  }
                </td>
              </tr>
              <tr>
                <td className='title'><div className='text'>交際希望</div></td>
                <td className='value'>{partnerProf.userdata_prof_association}</td>
                <td className='collation'>
                  {
                    ((myProf.userdata_prof_partner_association === '問わない') || (myProf.userdata_prof_partner_association.split(',').includes(partnerProf.userdata_prof_association)))? (
                      <OkIcon />
                    ): (
                      <NgIcon/>
                    )
                  }
                </td>
              </tr>
              <tr>
                <td className='title'><div className='text'>結婚歴</div></td>
                <td className='value'>{partnerProf.userdata_prof_marriage}</td>
                <td className='collation'>
                  {
                    ((myProf.userdata_prof_partner_marriage === '問わない') || (myProf.userdata_prof_partner_marriage.split(',').includes(partnerProf.userdata_prof_marriage)))? (
                      <OkIcon />
                    ): (
                      <NgIcon/>
                    )
                  }
                </td>
              </tr>
              <tr>
                <td className='title'><div className='text'>生活</div></td>
                <td className='value'>{partnerProf.userdata_prof_lifestyle}</td>
                <td className='collation'>
                  {
                    ((myProf.userdata_prof_partner_lifestyle === '問わない') || (myProf.userdata_prof_partner_lifestyle.split(',').includes(partnerProf.userdata_prof_lifestyle)))? (
                      <OkIcon />
                    ): (
                      <NgIcon/>
                    )
                  }
                </td>
              </tr>
              <tr>
                <td className='title'><div className='text'>子供</div></td>
                <td className='value'>{partnerProf.userdata_prof_child}</td>
                <td className='collation'>
                  {
                    ((myProf.userdata_prof_partner_child === '問わない') || (myProf.userdata_prof_partner_child.split(',').includes(partnerProf.userdata_prof_child)))? (
                      <OkIcon />
                    ): (
                      <NgIcon/>
                    )
                  }
                </td>
              </tr>
              <tr>
                <td className='title'><div className='text'>ペット</div></td>
                <td className='value'>{partnerProf.userdata_prof_pet}</td>
                <td className='collation'>
                  {
                    ((myProf.userdata_prof_partner_pet === '問わない') || (myProf.userdata_prof_partner_pet.split(',').includes(partnerProf.userdata_prof_pet)))? (
                      <OkIcon />
                    ): (
                      <NgIcon/>
                    )
                  }
                </td>
              </tr>
              <tr>
                <td className='title'><div className='text'>住居</div></td>
                <td className='value'>{partnerProf.userdata_prof_house}</td>
                <td className='collation'></td>
              </tr>
              <tr>
                <td className='title'><div className='text'>車</div></td>
                <td className='value'>{partnerProf.userdata_prof_car}</td>
                <td className='collation'></td>
              </tr>
              <tr>
                <td className='title'><div className='text'>タバコ</div></td>
                <td className='value'>{partnerProf.userdata_prof_smorking}</td>
                <td className='collation'>
                  {
                    ((myProf.userdata_prof_partner_smorking === '問わない') || (myProf.userdata_prof_partner_smorking.split(',').includes(partnerProf.userdata_prof_smorking)))? (
                      <OkIcon />
                    ): (
                      <NgIcon/>
                    )
                  }
                </td>
              </tr>
              <tr>
                <td className='title'><div className='text'>お酒</div></td>
                <td className='value'>{partnerProf.userdata_prof_drinking}</td>
                <td className='collation'>
                  {
                    ((myProf.userdata_prof_partner_drinking === '問わない') || (myProf.userdata_prof_partner_drinking.split(',').includes(partnerProf.userdata_prof_drinking)))? (
                      <OkIcon />
                    ): (
                      <NgIcon/>
                    )
                  }
                </td>
              </tr>
              <tr>
                <td className='title'><div className='text'>ギャンブル</div></td>
                <td className='value'>{partnerProf.userdata_prof_gambling}</td>
                <td className='collation'>
                  {
                    ((myProf.userdata_prof_partner_gambling === '問わない') || (myProf.userdata_prof_partner_gambling.split(',').includes(partnerProf.userdata_prof_gambling)))? (
                      <OkIcon />
                    ): (
                      <NgIcon/>
                    )
                  }
                </td>
              </tr>
              <tr>
                <td className='title'><div className='text'>血液型</div></td>
                <td className='value'>{partnerProf.userdata_prof_blood}</td>
                <td className='collation'></td>
              </tr>
              <tr>
                <td className='title'><div className='text'>星座</div></td>
                <td className='value'>{partnerProf.userdata_prof_constellation}</td>
                <td className='collation'></td>
              </tr>
            </tbody>
          </table>
        </Box>

        <Box
          id='myProfilePartnerBox'
          className='round12'
          boxShadow={2}
          style={{
            background:'#FFF',
            margin:'15px'
          }}
        >
          <h2  style={{padding:'10px',textAlign:'center'}}>
              パートナーへの希望
          </h2>
          <div align='right'>
            <PartProfileTableBalloon>
              あなたのプロフィールとの相性
            </PartProfileTableBalloon>
          </div>
          <table className='profileTable'>
            <tbody>
              <tr>
                <td className='title'>
                  <div className='text'>年齢</div>
                  {
                    (partnerProf.userdata_prof_partner_age_important === 1) &&
                    <span className='importantIcon'>重要</span>
                  }
                </td>

                <td className='value'>{partnerProf.userdata_prof_partner_age_low} 〜 {partnerProf.userdata_prof_partner_age_high}才</td>
                <td className='collation'>
                  {
                    ((partnerProf.userdata_prof_partner_age_low === '問わない') || (myProf.userdata_age >= partnerProf.userdata_prof_partner_age_low && myProf.userdata_age <=  partnerProf.userdata_prof_partner_age_high ))? (
                      <OkIcon />
                    ): (
                      <NgIcon/>
                    )
                  }
                </td>
              </tr>
              <tr>
                <td className='title'>
                  <div className='text'>地域</div>
                  {
                    (partnerProf.userdata_prof_partner_region_important === 1) &&
                    <span className='importantIcon'>重要</span>
                  }
                </td>
                <td className='value'>{partnerProf.userdata_prof_partner_region}</td>
                <td className='collation'>
                  {
                    ((partnerProf.userdata_prof_partner_region === '問わない') || (partnerProf.userdata_prof_partner_region.split(',').includes(myProf.userdata_prof_region)))? (
                      <OkIcon />
                    ): (
                      <NgIcon/>
                    )
                  }
                </td>
              </tr>
              <tr>
                <td className='title'>
                  <div className='text'>仕事</div>
                  {
                    (partnerProf.userdata_prof_partner_job_important === 1) &&
                    <span className='importantIcon'>重要</span>
                  }
                </td>
                <td className='value'>{partnerProf.userdata_prof_partner_job}</td>
                <td className='collation'>
                  {
                    ((partnerProf.userdata_prof_partner_job === '問わない') || (partnerProf.userdata_prof_partner_job.split(',').includes(myProf.userdata_prof_job)))? (
                      <OkIcon />
                    ): (
                      <NgIcon/>
                    )
                  }
                </td>
              </tr>
              <tr>
                <td className='title'>
                  <div className='text'>年収</div>
                  {
                    (partnerProf.userdata_prof_partner_income_important === 1) &&
                    <span className='importantIcon'>重要</span>
                  }
                </td>
                <td className='value'>{partnerProf.userdata_prof_partner_income.replace(/,/g, '\n')}</td>
                <td className='collation'>
                  {
                    ((partnerProf.userdata_prof_partner_income === '問わない') || (partnerProf.userdata_prof_partner_income.split(',').includes(myProf.userdata_prof_income)))? (
                      <OkIcon />
                    ): (
                      <NgIcon/>
                    )
                  }
                </td>
              </tr>
              <tr>
                <td className='title'>
                  <div className='text'>学歴</div>
                  {
                    (partnerProf.userdata_prof_partner_academic_important === 1) &&
                    <span className='importantIcon'>重要</span>
                  }
                </td>
                <td className='value'>{partnerProf.userdata_prof_partner_academic}</td>
                <td className='collation'>
                  {
                    ((partnerProf.userdata_prof_partner_academic === '問わない') || (partnerProf.userdata_prof_partner_academic.split(',').includes(myProf.userdata_prof_academic)))? (
                      <OkIcon />
                    ): (
                      <NgIcon/>
                    )
                  }
                </td>
              </tr>
              <tr>
                <td className='title'>
                  <div className='text'>体型</div>
                  {
                    (partnerProf.userdata_prof_partner_style_important === 1) &&
                    <span className='importantIcon'>重要</span>
                  }
                </td>
                <td className='value'>{partnerProf.userdata_prof_partner_style}</td>
                <td className='collation'>
                  {
                    ((partnerProf.userdata_prof_partner_style === '問わない') || (partnerProf.userdata_prof_partner_style.split(',').includes(myProf.userdata_prof_style)))? (
                      <OkIcon />
                    ): (
                      <NgIcon/>
                    )
                  }
                </td>
              </tr>
              <tr>
                <td className='title'>
                  <div className='text'>身長</div>
                  {
                    (partnerProf.userdata_prof_partner_height_important === 1) &&
                    <span className='importantIcon'>重要</span>
                  }
                </td>
                <td className='value'>{partnerProf.userdata_prof_partner_height_low} 〜 {partnerProf.userdata_prof_partner_height_high}</td>
                <td className='collation'>
                  {
                    ((partnerProf.userdata_prof_partner_height_low === '問わない') || (myProf.userdata_prof_height >= partnerProf.userdata_prof_partner_height_low && myProf.userdata_prof_height <=  partnerProf.userdata_prof_partner_height_high ))? (
                      <OkIcon />
                    ): (
                      <NgIcon/>
                    )
                  }
                </td>
              </tr>
              <tr>
                <td className='title'>
                  <div className='text'>交際希望</div>
                  {
                    (partnerProf.userdata_prof_partner_association_important  === 1) &&
                    <span className='importantIcon'>重要</span>
                  }
                </td>
                <td className='value'>{partnerProf.userdata_prof_partner_association}</td>
                <td className='collation'>
                  {
                    ((partnerProf.userdata_prof_partner_association === '問わない') || (partnerProf.userdata_prof_partner_association.split(',').includes(myProf.userdata_prof_association)))? (
                      <OkIcon />
                    ): (
                      <NgIcon/>
                    )
                  }
                </td>
              </tr>
              <tr>
                <td className='title'>
                  <div className='text'>結婚歴</div>
                  {
                    (partnerProf.userdata_prof_partner_marriage_important === 1) &&
                    <span className='importantIcon'>重要</span>
                  }
                </td>
                <td className='value'>{partnerProf.userdata_prof_partner_marriage}</td>
                <td className='collation'>
                  {
                    ((partnerProf.userdata_prof_partner_marriage === '問わない') || (partnerProf.userdata_prof_partner_marriage.split(',').includes(myProf.userdata_prof_marriage)))? (
                      <OkIcon />
                    ): (
                      <NgIcon/>
                    )
                  }
                </td>
              </tr>
              <tr>
                <td className='title'>
                  <div className='text'>生活</div>
                  {
                    (partnerProf.userdata_prof_partner_lifestyle_important === 1) &&
                    <span className='importantIcon'>重要</span>
                  }
                </td>
                <td className='value'>{partnerProf.userdata_prof_partner_lifestyle}</td>
                <td className='collation'>
                  {
                    ((partnerProf.userdata_prof_partner_lifestyle === '問わない') || (partnerProf.userdata_prof_partner_lifestyle.split(',').includes(myProf.userdata_prof_lifestyle)))? (
                      <OkIcon />
                    ): (
                      <NgIcon/>
                    )
                  }
                </td>
              </tr>
              <tr>
                <td className='title'>
                  <div className='text'>子供</div>
                  {
                    (partnerProf.userdata_prof_partner_child_important === 1) &&
                    <span className='importantIcon'>重要</span>
                  }
                </td>
                <td className='value'>{partnerProf.userdata_prof_partner_child}</td>
                <td className='collation'>
                  {
                    ((partnerProf.userdata_prof_partner_child === '問わない') || (partnerProf.userdata_prof_partner_child.split(',').includes(myProf.userdata_prof_child)))? (
                      <OkIcon />
                    ): (
                      <NgIcon/>
                    )
                  }
                </td>
              </tr>
              <tr>
                <td className='title'>
                  <div className='text'>ペット</div>
                  {
                    (partnerProf.userdata_prof_partner_pet_important === 1) &&
                    <span className='importantIcon'>重要</span>
                  }
                </td>
                <td className='value'>{partnerProf.userdata_prof_partner_pet}</td>
                <td className='collation'>
                  {
                    ((partnerProf.userdata_prof_partner_pet === '問わない') || (partnerProf.userdata_prof_partner_pet.split(',').includes(myProf.userdata_prof_pet)))? (
                      <OkIcon />
                    ): (
                      <NgIcon/>
                    )
                  }
                </td>
              </tr>
              <tr>
                <td className='title'>
                  <div className='text'>タバコ</div>
                  {
                    (partnerProf.userdata_prof_partner_smorking_important === 1) &&
                    <span className='importantIcon'>重要</span>
                  }
                </td>
                <td className='value'>{partnerProf.userdata_prof_partner_smorking}</td>
                <td className='collation'>
                  {
                    ((partnerProf.userdata_prof_partner_smorking === '問わない') || (partnerProf.userdata_prof_partner_smorking.split(',').includes(myProf.userdata_prof_smorking)))? (
                      <OkIcon />
                    ): (
                      <NgIcon/>
                    )
                  }
                </td>
              </tr>
              <tr>
                <td className='title'>
                  <div className='text'>お酒</div>
                  {
                    (partnerProf.userdata_prof_partner_drinking_important === 1) &&
                    <span className='importantIcon'>重要</span>
                  }
                </td>
                <td className='value'>{partnerProf.userdata_prof_partner_drinking}</td>
                <td className='collation'>
                  {
                    ((partnerProf.userdata_prof_partner_drinking === '問わない') || (partnerProf.userdata_prof_partner_drinking.split(',').includes(myProf.userdata_prof_drinking)))? (
                      <OkIcon />
                    ): (
                      <NgIcon/>
                    )
                  }
                </td>
              </tr>
              <tr>
                <td className='title'>
                  <div className='text'>ギャンブル</div>
                  {
                    (partnerProf.userdata_prof_partner_gambling_important === 1) &&
                    <span className='importantIcon'>重要</span>
                  }
                </td>
                <td className='value'>{partnerProf.userdata_prof_partner_gambling}</td>
                <td className='collation'>
                  {
                    ((partnerProf.userdata_prof_partner_gambling === '問わない') || (partnerProf.userdata_prof_partner_gambling.split(',').includes(myProf.userdata_prof_gambling)))? (
                      <OkIcon />
                    ): (
                      <NgIcon/>
                    )
                  }
                </td>
              </tr>
            </tbody>
          </table>
        </Box>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
	return {
    my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
